document.addEventListener('DOMContentLoaded', () => {
  // Function to move the element and update its style
  function moveSwitcher() {
    const switcher = document.querySelector('.ts-switcher-individual');
    const headerIcons = document.querySelector('.header__inline-menu.hidden-mb .nav-header .header__icons');
    if (switcher && headerIcons) {
      headerIcons.insertBefore(switcher, headerIcons.firstChild);
      switcher.style.position = 'relative';
      switcher.style.top = '0';
      switcher.style.right = '0';
   
    }
  }

  // Set up the observer
  const observer = new MutationObserver(() => {
    const switcher = document.querySelector('.ts-switcher-individual');
    if (switcher) {
      moveSwitcher();
      observer.disconnect();
    }
  });

  // Only start observing once the body is available
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  } else {
    // Just in case body isn't ready — fallback
    window.addEventListener('load', () => {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }
});
